import { render } from "./ContactUs.vue?vue&type=template&id=aaaef3e0"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=aaaef3e0&lang=scss"

import exportComponent from "/home/runner/work/intelli-landing-frontend/intelli-landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__